"use client";

import styles from "./index.module.scss";
import {questions} from "./data";
import Faq from "@/app/_components/Shared/Faq";
import {useCallback, useMemo, useState} from "react";
import SearchIcon from "@/app/icons/search.svg";
import TextInput from "@/app/_components/Shared/TextInput";
export default function Questions() {
    const [search, setSearch] = useState("");

    const filteredQuestions = useMemo(() => {
        if (!search) return questions;
        let results = [];
        questions.map((section) => {
            results.push({
                title: section.title,
                questions: section.questions.filter((question) => {
                    return question.title.toLowerCase().includes(search.toLowerCase()) || question.content.toLowerCase().includes(search.toLowerCase());
                })
            });
        });
        return results;
    }, [search]);

    const handleSearch = useCallback((e) => {
        setSearch(e.target.value);
    }, [setSearch]);

    return (
        <div className={styles.container}>
            <div className="container-wrapper">
                <h1>FAQ</h1>
                <TextInput value={search} onChange={handleSearch} icon={SearchIcon}
                           placeholder="Search for the topics..."/>
                {
                    filteredQuestions.map((section, index) => (
                        section.questions.length > 0 &&
                        <Faq key={index} data={section.questions} title={section.title}/>
                    ))
                }
            </div>
        </div>
    );
}
